import api from "../utils/axios";
import { useQuery } from "@tanstack/react-query";

const AUTH_SCHEDULES_KEY = ["authSchedules"];

// GET all auth schedules (optional comma-separated `select` fields)
export const useAuthSchedulesQuery = (select, options = {}) => {
  return useQuery({
    queryKey: select ? [...AUTH_SCHEDULES_KEY, select] : AUTH_SCHEDULES_KEY,
    queryFn: async () => {
      const params = select ? `?select=${select}` : "";
      const res = await api.get(`/admin/authSchedule${params}`);
      return res.data?.data || [];
    },
    ...options,
  });
};
